import React from 'react';
import { Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import MessageInfoSection from '../MessageInfoSection/MessageInfoSection';
import { getDangerTitleColor, getMessageDetailsThemeColors } from '../MessageDetails.helpers';

const { Text } = Typography;

const MessageErrorInfo = ({ message, isDarkMode }) => {
    const { t } = useTranslation();
    const themeColors = getMessageDetailsThemeColors(isDarkMode);

    if (!message?.error_type || !message?.error_details) return null;

    return (
        <MessageInfoSection
            title={t('error_information')}
            titleColor={getDangerTitleColor(isDarkMode)}
        >
            <Space direction="vertical">
                <Text style={{ color: themeColors.text }}>{t('error_type')}: {message.error_type}</Text>
                <Text style={{ color: themeColors.text }}>{t('error_details')}: {message.error_details}</Text>
            </Space>
        </MessageInfoSection>
    );
};

export default MessageErrorInfo;
